import React, { useState } from "react";
import * as XLSX from "xlsx";
import Table from "../../components/common/table/Table";
import { putApi } from "../../services/api/globalApi";
import { getNumberFromString } from "../../utils/getNumberFromString";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { barcodesListColumns, notFoundBarcodesListColumns } from "../../constant/tablesColumns/tablesColums";

function BarcodesUpload() {
  const [jsonData, setJsonData] = useState([]);
  const [notFoundData, setNotFoundData] = useState([]);
  const [error, setError] = useState("");

  const handleFileUpload = (event) => {
    setError("");
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        const firstRow = json[0] || {};
        const isPost = "بارکد" in firstRow;
        const isTipax = "کد قرارداد" in firstRow;

        if (!isPost && !isTipax) {
          throw new Error("فرمت فایل شناسایی نشد. ستون «بارکد» (پست) یا «کد قرارداد» (تیپاکس) یافت نشد.");
        }

        const barcodeData = json.map((item) => {
          if (isPost) {
            if (!item["بارکد"] || !item["نام گ"]) {
              throw new Error("بارکد یا نام گ در برخی از آیتم‌ها موجود نیست.");
            }
            return {
              barcode: String(item["بارکد"]).trim(),
              trackingCode: getNumberFromString(item["نام گ"]),
            };
          } else {
            if (!item["کد قرارداد"] || !item["گیرنده"]) {
              throw new Error("کد قرارداد یا گیرنده در برخی از آیتم‌ها موجود نیست.");
            }
            return {
              barcode: String(item["کد قرارداد"]).trim(),
              trackingCode: getNumberFromString(item["گیرنده"]),
            };
          }
        });
        setNotFoundData([]);
        setJsonData(barcodeData);
      } catch (err) {
        setError(err.message);
        setJsonData([]);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleUploadBarcode = async () => {
    const path = "admin/orderShipmentTrackers/setBarcodes";
    const body = {
      barcodes: jsonData,
    };
    try {
      const response = await putApi({ path, body });
      successMessage("عملیات با موفقیت اجام شد.");
      setJsonData([]);
      if (response?.data?.result?.notFoundTrackingCodes?.length) {
        setNotFoundData(response?.data?.result?.notFoundTrackingCodes);
      }
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 text-gray-800 dark:text-white rounded-3xl p-6">
      <h3 className="">آپلود بارکد</h3>
      <h1 className="mt-3">فایل اکسل خود را بارگذاری کنید</h1>
      <div className="w-11/12 mx-auto mt-6">
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileUpload}
          className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
        />
        {error ? (
          <p className="text-red-500 w-full py-4">{error}</p>
        ) : (
          <div className="w-full my-4">
            <button
              onClick={handleUploadBarcode}
              type="button"
              className="text-white bg-gradient-to-r from-green-500 via-green-600 to-green-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2"
            >
              آپلود
            </button>
          </div>
        )}
        <Table columns={barcodesListColumns} rows={jsonData} />
        {notFoundData?.length ? (
          <>
            <p className="my-4">لیست سفارشاتی که یافت نشدند</p>
            <Table columns={notFoundBarcodesListColumns} rows={notFoundData} />
          </>
        ) : null}
      </div>
    </div>
  );
}

export default BarcodesUpload;
